/**
 * #609 — el cartel de la línea: de dónde salió este precio unitario.
 *
 * Se renderiza igual en la tabla de escritorio (`QuotationItemRow`) y en la
 * tarjeta de móvil (`QuotationItemCard`), porque las dos vistas son la misma
 * pantalla para el mismo usuario y una sola de las dos arreglada es la deriva
 * de siempre. Ver `priceSourceDisplay.js` para el mapeo y para por qué NULL no
 * se pinta.
 *
 * @module pages/quotations/PriceSourceBadge
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import { describePriceSource } from './priceSourceDisplay';

/**
 * @param {Object} props
 * @param {string|null} props.priceSource - `quotation_items.price_source`
 * @param {number} props.index - índice de la línea (para el data-testid)
 * @param {'table'|'card'} props.view - las DOS vistas se montan siempre y el
 *   CSS esconde una; sin distinguirlas, el `data-testid` sale duplicado en el
 *   DOM y cualquier test que lo busque encuentra dos.
 */
const PriceSourceBadge = ({ priceSource, index, view }) => {
  const descriptor = describePriceSource(priceSource);
  if (!descriptor) return null;

  const suffix = view === 'card' ? '-card' : '';

  return (
    <Badge
      bg={descriptor.variant}
      className="d-inline-flex align-items-center gap-1 mt-1 text-wrap text-start"
      title={descriptor.title}
      data-testid={`quotation-item-price-source${suffix}-${index}`}
      data-price-source={priceSource}
    >
      <i className={`bi ${descriptor.icon}`} aria-hidden="true"></i>
      <span>{descriptor.label}</span>
    </Badge>
  );
};

PriceSourceBadge.propTypes = {
  priceSource: PropTypes.string,
  index: PropTypes.number.isRequired,
  view: PropTypes.oneOf(['table', 'card']),
};

PriceSourceBadge.defaultProps = {
  priceSource: null,
  view: 'table',
};

export default PriceSourceBadge;
